export const Messages = {
  CONNECT: 'CONNECT',
  DISCONNECT: 'DISCONNECT',
  HEARTBEAT: 'HEARTBEAT'
}
